import React, { Fragment } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { X } from 'react-feather'

import { ReportViewer } from './ReportViewer'

export const ModalModule = ({ useFetchInit, access }) => {
    
    const { dataModal, toggleClose } = useFetchInit

    const { open, titleModal, componentModal, dataRequest } = dataModal
    // const { CONTENEDOR, NUMERO_BL, BOOKING, TYPE } = (dataRequest && dataRequest.data) || {}

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={toggleClose}
                fullWidth
                maxWidth='md'
                aria-labelledby='customized-dialog-title'
                tabIndex={-1}
            >
                <DialogTitle id='customized-dialog-title' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titleModal}
                    <IconButton aria-label='close' onClick={toggleClose}>
                        <X />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    
                    {componentModal === 'ReportViewer' && (
                        <ReportViewer useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                    
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}